module.exports = __webpack_public_path__ + "static/media/tittle2.a6cccde7.jpg";